import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FunctionsService } from 'src/app/services/functions.service';

@Component({
  selector: 'app-image-modal',
  templateUrl: './image-modal.component.html'
})
export class ImageModalComponent implements OnInit {
  @Input() link: string;

  constructor(
    public activeModal: NgbActiveModal
  ) { }

  ngOnInit() {
  }
}
